import { ActivitiesService } from "./ActivitesService";
import { ThreadedMessageService } from "./ThreadedMessageService";
import { API_HOST_EXPERTS_APPLY, API_ROOT_COMMS } from "../config";

export const activitiesService = new ActivitiesService(API_ROOT_COMMS);
export const threadedMessageService = new ThreadedMessageService(API_HOST_EXPERTS_APPLY);